<template>
  <div class="proceed">
    <action-button
      v-if="cancel"
      label="Back"
      :theme="{ primary, secondary, event, danger }"
      @customEvent="handleBackEvent"
      mode="outline"
      :style="{ width: 'auto' }"
    ></action-button>
    <action-button
      :label="getPlaceholder"
      :disabled="disabled"
      @customEvent="handleClickEvent"
      :theme="{ primary, secondary, event, danger }"
      :style="{ width: 'auto', marginLeft: 'auto' }"
    ></action-button>
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
export default {
  name: "proceed-button",
  components: {
    ActionButton
  },
  props: {
    placeholder: {
      type: [String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: [Boolean],
      default: false
    },
    default: {
      type: [Boolean],
      default: true
    }
  },
  computed: {
    getPlaceholder() {
      if (this.default) {
        if (this.placeholder) {
          return "Proceed to " + this.placeholder;
        }
        return "Choose space";
      } else {
        return this.placeholder;
      }
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  methods: {
    handleClickEvent() {
      this.$emit("proceed", this.placeholder);
    },
    handleBackEvent() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="scss" scoped>
.proceed {
  display: flex;
  &-cancel {
    background: $gray-500 !important;
    &:hover {
      background: $gray-400 !important;
    }
  }
}
</style>
